var _circle, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 99,
    viewBox: "0 0 74 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5959,
    cy: 24.8563,
    r: 16,
    transform: "rotate(-15 19.5959 24.8563)",
    fill: "#E8ECED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4394 87.3189L64.5695 84.0727C63.8781 81.4924 64.1315 78.7779 65.2321 76.3419L65.87 74.9517C67.8114 70.7738 68.2396 66.0498 67.0426 61.5829L62.7828 45.6848L61.7494 41.8282C61.0134 39.0815 58.2005 37.4562 55.4555 38.1917C52.7106 38.9272 51.0872 41.7412 51.8232 44.488L50.8047 40.6869C50.0687 37.9401 47.2558 36.3148 44.5108 37.0503C41.849 37.7635 40.2514 40.4517 40.8467 43.1172L39.7687 39.0941C39.0327 36.3474 36.2198 34.7221 33.4749 35.4576C30.7299 36.1931 29.1065 39.0071 29.8425 41.7539L25.486 25.4951C24.8055 22.7335 21.9926 21.1082 19.2476 21.8437L19.2199 21.8512C16.4749 22.5867 14.8515 25.4007 15.5875 28.1474L22.1 52.4523C21.364 49.7055 18.5511 48.0802 15.8061 48.8157C13.0612 49.5512 11.4378 52.3652 12.1738 55.112L13.2071 58.9686L17.2886 74.2007C18.8721 80.1105 23.1113 84.9517 28.7839 87.2679L29.5203 87.5761C32.7951 88.9289 35.2379 91.7239 36.1524 95.1366",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.898 41.739L33.6821 55.8613",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8745 43.1097L43.5806 53.2089",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8786 44.473L53.5067 50.5492",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1 52.4521L26.7316 69.7374",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.623006dd6893dca07ca783033823015c.svg";
export { ForwardRef as ReactComponent };